import { Button, Col, Flex, Row, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useTranslation } from "react-i18next";

const AdminCompanyFilter = ({
    handleSearch = () => { },
    userAdminListOptions = []
}) => {
    const { t } = useTranslation();

    return (
        <FormAntd
            onFinish={handleSearch}
        >
            <FormItem shouldUpdate={(prev, curv) => {
                return false
            }}>
                {({ getFieldValue, setFieldValue, resetFields }) => {
                    return (
                        <Space direction="vertical" size={24} style={{ width: "100%" }}>
                            <Flex vertical gap={16}>
                                <Row gutter={24} style={{ marginLeft: "0px" }}>
                                    <Col span={8}>
                                        <FormInput
                                            name="companyName"
                                            label={t("signup.input.companyName")}
                                            size="large"
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <FormInput
                                            name="taxId"
                                            label={t("response_company.label.tax_id")}
                                            size="large"
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <FormSelect
                                            name="stmUserIds"
                                            label={t("response_company.label.careTaker")}
                                            size="large"
                                            mode="multiple"
                                            options={userAdminListOptions}
                                        />
                                    </Col>
                                </Row>
                                <Row gutter={24} style={{ marginLeft: "0px" }}>
                                    <Col span={8}>
                                        <FormDatePicker
                                            name="startDate"
                                            label={t("response_company.label.start_date")}
                                            size="large"
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <FormDatePicker
                                            name="endDate"
                                            label={t("response_company.label.exp_date")}
                                            size="large"
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <FormSelect
                                            name="status"
                                            label={t("response_company.label.status")}
                                            size="large"
                                            options={[
                                                { value: 'INACTIVE', label: t("response_company.label.inactive") },
                                                { value: 'ACTIVE', label: t("response_company.label.active") },
                                            ]}
                                        />
                                    </Col>
                                </Row>
                            </Flex>
                            <Row gutter={24} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                <Button
                                    type="default"
                                    onClick={() => { resetFields() }}
                                    style={{ borderRadius: "8px" }} size="large"
                                >
                                    {t("common.cancel").toUpperCase()}
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" }}
                                    size="large"
                                >
                                    {t("common.search").toUpperCase()}
                                </Button>
                            </Row>
                        </Space>
                    )
                }}
            </FormItem>
        </FormAntd>
    )
}

export default AdminCompanyFilter;